// extracted by mini-css-extract-plugin
export default {"title":"FAQ-module__title--_xDMJ","note":"FAQ-module__note--opNIN"};